module.exports = __webpack_public_path__ + "img/benefit_la-bowl-pregame-tailgate.868c7560.jpg";